module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/id/4-03665a1c1bc3827b1ae8c0f308992f71.jpg";